<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/serve/01/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>    
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>            
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>    
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow, 
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/serve/01/pic-1.png'),
                    require('@/assets/image/serve/01/pic-2.png'),
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){  

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){        
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        padding-bottom:100px;
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2n+1){
        background-color:#ffffff;
    }
    .page-content-child:nth-child(2n+2){
    background-color: #f9f9f9;
    }
    .page-content-box{
        /* background-color:#fff; */
        /* border-radius:16px; */
        overflow:hidden;
        /* margin-top:-100px; */
        min-height:500px;
    }

    @media screen and (max-width: 1200px){
        .page-content .content-w{
            padding-left:15px;
            padding-right:15px;
        }
    }
</style>
